module.exports = __webpack_public_path__ + "static/img/no-message.2951199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/no-message.png
// module id = jWQ3
// module chunks = 4